"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameInfoScene = void 0;
const CTGMenuScene_1 = require("../CTGMenuScene");
const CTGHighScores_1 = require("../CTGHighScores");
class CTGGameInfoScene extends CTGMenuScene_1.CTGMenuScene {
    constructor() {
        super("CTGGameInfoScene");
        this.start_level = 0;
    }
    onCreate() {
        super.onCreate();
        this.game_modes = this.init_data.game_modes;
        this.setTitle(this.save_key());
        let best = CTGHighScores_1.HighScores.get_best_score(this.save_key());
        this.addText("Best: " + (best == null ? "N/A" : best));
        if (best >= 5) {
            let levels = [];
            for (let i = 0; i <= best; i += 5) {
                levels.push("" + i);
            }
            this.addPreferenceOptionSingleDescription("Level: ", "", levels, (idx) => {
                this.start_level = idx * 5;
            }, 0);
        }
        this.addOption("Play", null, () => {
            this.startScene('CTGGameScene', { game_modes: this.game_modes, initial_level: this.start_level });
        });
    }
    save_key() {
        return this.game_modes.length == 1 ? this.game_modes[0].title : "Panic";
    }
}
exports.CTGGameInfoScene = CTGGameInfoScene;
